import Main from "../../../assets/images/projects/final-project/main.png";
import Content1 from "../../../assets/images/projects/final-project/content-1-transparent.png";
import Content2 from "../../../assets/images/projects/final-project/content-2-transparent.png";
import Content3 from "../../../assets/images/projects/final-project/content-3-transparent.png";
import Content4 from "../../../assets/images/projects/final-project/content-4.png";
import Content5 from "../../../assets/images/projects/final-project/content-5-transparent.png";

import { ProjectDetailProps } from "../props";

export default {
  title: "Uni-Final Project: DISC video",
  timeline: "Q2 - 2019",
  context:
    "Describing the process of educational animated film Knowing DISC Personality in Ourselves and Others (Indonesia video) built. Focusing on the each character design works since these characters are the most representable of the DISC personality that want to be shared on the video as an introduction of the DISC theory.",
  team: [],
  thumbnail: Main,
  contents: [
    {
      left: {
        title: "Background",
        content: (
          <div>
            <p>
              A habit that humans make to describe themselves who they are as an
              individual. Some of the researchers and scientists are trying to
              find out more about the human description. Starting from the
              diversity of humans to speak, how to act and behave which is used
              as a theoretical understanding which is called personality.
            </p>
            <p>
              The theory of personality or personality is continuously explored
              and developed by various researchers to find out how a person
              defines his personality. It goes back even to 2400 years, in 400
              BC. Humans are predicted from a part of the temperament which is
              categorized into a unique pattern and is owned by the individual.
            </p>
          </div>
        ),
      },
      right: {
        title: "",
        content: (
          <div>
            <p>
              And until this modern era, personality patterns have developed
              quite deeply and become a method for predicting personality. One
              prediction method that is quite easy to understand and apply in
              several aspects is called the DISC theory.
            </p>
            <p>
              Seeing an interesting opportunity how a personality can be
              predicted. The author hopes to be able to provide an educational
              understanding that can be applied to get to know yourself and
              those around you better.
            </p>
          </div>
        ),
      },
      bottomImage: "",
    },
    {
      left: {
        title: "Process",
        content: (
          <div>
            <p>
              There are various kinds of experiments through character design
              theory as many various kinds of experiments and sketches that I
              made. Drawing styles of several types of visuals are used to
              achieve the desired visuals.
            </p>
            <p>
              In the end, the author uses visuals that are at the midpoint where
              they don't really describe significant "reality" and "meaning"
              which is understandable enough to give a message and each
              character has the same physical uniformity, but there are
              differences in the behavior of each character.
            </p>
            <p>
              This can be seen from the visual form of each character. In the
              style of drawing characters, there are variations that the author
              explores which can be seen in the design character sketch image.
            </p>
          </div>
        ),
      },
      right: {
        content: <img alt="" src={Content1} style={{ width: "100%" }} />,
      },
      bottomImage: Content2,
    },
    {
      left: {
        title: "Treatment/Storyboard",
        content: (
          <div>
            <p>
              In the educational animated film "Knowing DISC Personality in
              Ourselves and Others", the writer describes four personality types
              with 4 types of characters. The four types of characters are
              displayed in animated visuals and in different colors according to
              their respective personalities. The aim is to provide an
              informative visual image that is easier to understand and
              impressive, so that it can attract the attention of the audience.
              In addition, there are several elements that support the visual
              image of the character type. At the end of the goal is to get to
              know the personality of oneself and those around.
            </p>
          </div>
        ),
      },
      bottomImage: Content3,
    },
    {
      left: {
        title: "",
        content: "",
      },
      right: {
        title: "",
        content: "",
      },
      bottomImage: Content4,
    },
    {
      left: {
        title: "",
        content: "",
      },
      right: {
        title: "",
        content: "",
      },
      bottomImage: Content5,
    },
    {
      left: {
        title: "Final Look Character",
        content: (
          <div>
            <p>
              Character behavior is obtained from the use of color for each
              character. Most of the character colors use the principles of
              color theory in split complementary and analogous to provide
              interesting color combinations and give meaning according to the
              dominance of the color.
            </p>
            <p>
              In the Dominant type there is a dominant color to represent risk,
              ‘fire’, and excitement. The Interactive type is dominated by
              bright colors, namely yellow and blue, which aims to describe the
              spirit in the interactive and blue as it gives a "trustworthy"
              effect.
            </p>
          </div>
        ),
      },
      right: {
        title: "",
        content: (
          <div>
            <p>
              The dominant Steady colors, namely green and brown or dark orange,
              represent simplicity and stability as well as a warm (nurturing)
              person. And in the Compliance type, the predominance of the main
              color is blue which broadly describes a calm and responsible
              person.
            </p>
            <p>
              The uniformity of character forms is made to give the impression
              of a rhythm and generalization in accordance with the main
              objectives of the characteristics. Not focus on the physical or
              visible form but on the metaphorical behavior of the visual colors
              of the characters.
            </p>
          </div>
        ),
      },
    },
    {
      left: {
        title: "",
        content: (
          <iframe
            style={{ width: "100%", height: "36vw" }}
            title="youtube"
            src="https://youtube.com/embed/Y5LA_K8i058"
          />
        ),
      },
    },
    {
      left: {
        title: "Afterwords",
        content: (
          <div>
            <p>
              There are many methods that describe how human characteristics
              fall into categories. One of them is DISC. As in studying the
              diverse and unique characteristics of humans make understanding
              abstract and difficult to understand. The purpose of categorizing
              some of these methods is to greatly assist human civilization in
              understanding relatives, family, friends, and so on.
            </p>
            <p>
              One of the most common examples is in the world of work. In the
              world of work, many companies have realized how important this
              method is. This method can be used to support the talents of each
              employee as an important asset in the company.
            </p>
            <p>
              They use the DISC method with an assessment test to help
              categorize these characteristics into 4 categories: Dominant,
              Interactive, Stable, and Compliance. Then after knowing each
              characteristic that each employee has, in order to improve the
              performance of the worker and the team in it, go back to how to
              respond to each of the human resources / HRD division.
            </p>
          </div>
        ),
      },
      right: {
        title: "",
        content: (
          <div>
            <p>
              An example that can be illustrated in everyday life is that when
              we already know the different and unique human characteristics it
              is not enough. And just like how the attitude of HRD to its
              employees, it also applies to us to respond to how these
              characteristics must be understood more deeply. About how we can
              better blend, communicate, and respond to the different
              personality characteristics of humans.
            </p>
            <p>
              The authors hope that with the introduction of this method, we can
              go to the next step on how to tolerate others better. That is all
              and thank you. Hopefully you enjoy watch the video!
            </p>
          </div>
        ),
      },
      bottomImage: "",
    },
  ],
} as ProjectDetailProps;
